import AuthorPage from '../../../components/AuthorPage/AuthorPage';
import { buildPrimaryAuthorPage } from '../../../util/buildPrimaryAuthorPage';
import { Layout } from '../[[...slug]]';

// Build the page using the utility
const { getStaticProps, getStaticPaths, Page } = await buildPrimaryAuthorPage({
    site: 'AGENTS',
    LayoutComponent: Layout,
    ContentComponent: AuthorPage,
    hasStickyNav: true,
});

// Next.js expects named exports, so we use a wrapper
export { getStaticProps, getStaticPaths };

export default Page;
